// Small reusable Eyebrow label: ---- LABEL · SUBLABEL ·
export const Eyebrow = ({ label, sub, className = "" }) => (
  <div className={`eyebrow ${className}`}>
    <span>{label}</span>
    {sub && (
      <>
        <span className="dot" />
        <span>{sub}</span>
      </>
    )}
  </div>
);
